import { lazy, Suspense } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { SiteFrame } from "./components/SiteFrame";
import { AccountPage } from "./pages/AccountPage";
import { ArenaPage } from "./pages/ArenaPage";
import { DiscoverPage } from "./pages/DiscoverPage";
import { ForgePage } from "./pages/ForgePage";
import { HomePage } from "./pages/HomePage";
import { MarketPage } from "./pages/MarketPage";
import { RoadmapPage } from "./pages/RoadmapPage";
import { TerminalPage } from "./pages/TerminalPage";
import { WorldPage } from "./pages/WorldPage";
import {GraphicNovelsPage} from './pages/GraphicNovelsPage';

import { SocialsPage } from "./pages/SocialsPage";

const LorePage = lazy(() => import("./pages/LorePage").then((module) => ({ default: module.LorePage })));

function GraphicNovelsRoute() {
  const { pathname, search, hash } = useLocation();
  return pathname.endsWith("/")
    ? <GraphicNovelsPage />
    : <Navigate to={{ pathname: "/graphic-novels/", search, hash }} replace />;
}

export default function App() {
  return (
    <Routes>
      <Route element={<SiteFrame />}>
        <Route index element={<Suspense fallback={<div className="lore-route-loading">Opening the world beneath…</div>}><LorePage /></Suspense>} />
        <Route path="play" element={<HomePage />} />
        <Route path="world" element={<WorldPage />} />
        <Route path="graphic-novels" element={<GraphicNovelsRoute />} />
        <Route path="forge" element={<ForgePage />} />
        <Route path="arena" element={<ArenaPage />} />
        <Route path="market" element={<MarketPage />} />
        <Route path="discover" element={<DiscoverPage />} />
        <Route path="terminal" element={<TerminalPage />} />
        <Route path="socials" element={<SocialsPage />} />
        <Route path="roadmap" element={<RoadmapPage />} />
        <Route path="lore" element={<Navigate replace to="/" />} />
        <Route path="lore-2" element={<Navigate replace to="/" />} />
        <Route path="account" element={<AccountPage />} />
      </Route>
    </Routes>
  );
}
